module.exports = {
  language       : 'language',
  _back          : 'Back',
  spanish        : 'Spanish',
  english        : 'English',
  capture_screen : 'Screenshot',
  description    : 'Description',
  titleApp       : 'Softaculous (Installer - Applications)',
  messageApp     : 'With our plans you can access the catalog of 372 ready-to-install applications with a few clicks.'

}



// WEBPACK FOOTER //
// ./src/translate/en-US.js